<template>
  <section class="section-dashboard mt-132">
    <div class="container">
      <div class="section-title">
        My <span class="main-green-color">Account</span>
      </div>

      <DashboardTab isActiveIndex="1" />

      <h3 class="mb-32">Dashboard</h3>
      <DashobardSectionMain />
    </div>
  </section>
</template>

<script>
import DashobardSectionMain from "../../../components/sections/Dashboard/01_DashobardSectionMain.vue";
import DashboardTab from "../../helpers/DashboardTab.vue";

import {
  Administrator,
  Reseller,
  Subscriber,
} from "../../../store/users.type.js";

export default {
  components: {
    DashobardSectionMain,
    DashboardTab,
  },
  computed: {
    userRole: {
      get() {
        return this.$store.state.RoleUserStore.userRole;
      },
    },
  },
  methods: {},
  data() {
    return {
      Administrator: Administrator,
      Reseller: Reseller,
      Subscriber: Subscriber,
    };
  },
};
</script>

<style>
@import "../../../assets/styles/components/pages/Dashboard/DashboardPage.css";
@import "../../../assets/styles/components/pages/Landing/HomePage.css";
</style>
